import {
  getInspection,
  getInspections,
  getInspectionsAll,
} from '../../services/sinisterInspections/sinisterInspections.service';

export const SINISTER_INSPECTION_QUERY = ' SINISTER_INSPECTION_QUERY';

export const sinisterInspectionsQuery = async ({ pageParam = 1 }) => {
  const request = await getInspections(pageParam);
  return request.data;
};

export const sinisterInspectionsQueryAll = async ({ pageParam = 1 }) => {
  const request = await getInspectionsAll(pageParam);
  return request.data;
};

export const sinisterInspectionQuery = async ({ queryKey }: any) => {
  const params = queryKey[1];
  const request = await getInspection(params.id);
  return request.data;
};
